export default function({countable, id}: {countable: any[] | null, id?: string}) {
    if(countable == null)
        return <span className="events" id={id}>(Daten aktuell nicht abrufbar)</span>
    return <span className="events" id={id}>({countable.length == 0 ? 'Keine Ereignisse' : (countable.length > 1 ? (countable.length +' Ereignisse') : '1 Ereignis')})</span>
}